import React, { useCallback, useMemo } from 'react'

import { FieldProps } from '../../../../../../../@types/types'
import { AbstractScreenValidationResult } from '../../../../../../../@types/validation-types'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

export interface SmokingAllowedProps extends FieldProps<AbstractScreenValidationResult> {}

enum SmokingAllowedOptions {
  NO_INFORMATION = 'NO_INFORMATION',
  YES = 'YES',
  NO = 'NO',
}

const SmokingAllowedOptionKeys = Object.keys(SmokingAllowedOptions)

export function mapNonSmoker(value: string) {
  switch (value as SmokingAllowedOptions) {
    case SmokingAllowedOptions.NO:
      return true
    case SmokingAllowedOptions.YES:
      return false
    case SmokingAllowedOptions.NO_INFORMATION:
    default:
      return undefined
  }
}

const SmokingAllowed: React.FC<SmokingAllowedProps> = ({
  insertionData,
  screenName,
  onChange,
  wrapperClassName = getDefaultClasses('full'),
}) => {
  const smokingAllowedOption = useMemo(() => {
    if (insertionData.estateFeatures?.nonSmoker === true) {
      return SmokingAllowedOptions.NO
    } else if (insertionData.estateFeatures?.nonSmoker === false) {
      return SmokingAllowedOptions.YES
    } else {
      return SmokingAllowedOptions.NO_INFORMATION
    }
  }, [insertionData.estateFeatures?.nonSmoker])

  const handleChange = useCallback(
    (value: string) => {
      onChange({ screen: screenName, property: 'estateFeatures.nonSmoker' }, mapNonSmoker(value))
    },
    [onChange, screenName]
  )

  return (
    <div className={wrapperClassName}>
      <ChipOptionField
        id='smoking-allowed'
        propertyName='smokingAllowed'
        option={smokingAllowedOption}
        options={SmokingAllowedOptionKeys}
        translation={'wizard.screen.otherFacilities.smokingAllowedOptions.'}
        labelTranslationKey={'wizard.screen.otherFacilities.smokingAllowed'}
        onChange={handleChange}
      />
    </div>
  )
}

export default SmokingAllowed
